function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "8",
  viewBox: "0 0 14 8",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-.4%",
  y: "-4.7%",
  width: "100.8%",
  height: "109.4%",
  filterUnits: "objectBoundingBox",
  id: "a"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "2",
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  id: "b",
  d: "M0 0h1440v128H0z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1182 -61)"
}, /*#__PURE__*/React.createElement("use", {
  filter: "url(#a)",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.942 0h12.116c.838 0 1.257 1.02.664 1.618L7.666 7.723a.939.939 0 01-1.332 0L.278 1.618C-.315 1.02.104 0 .942 0z",
  fillRule: "nonzero",
  fill: "currentColor"
}))));